/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Injectable } from '@angular/core';
import { EnvSettingsService } from 'src/app/core/services/env-settings.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { StorageKey } from 'src/app/models/application-enum.model';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class AutoLogoutService {

  private _logOutPrompt: BehaviorSubject<boolean>;
  logOutPrompt$: Observable<boolean>;
  constructor(private _envSettings: EnvSettingsService,
    private msalService: MsalService,
    private _http: HttpClient) {
    this._logOutPrompt = new BehaviorSubject<boolean>(false);
    this.logOutPrompt$ = this._logOutPrompt.asObservable()

  }

  initiateTimer() {
    this.reset();
    this.check();
    this.initListener();
    this.initInterval();
  }

  get lastAction() {
    return parseInt(sessionStorage.getItem(StorageKey.LastAction));
  }
  set lastAction(value) {
    sessionStorage.setItem(StorageKey.LastAction, new Date().getTime().toString());
  }
  initListener() {
    document.body.addEventListener('click', () => this.reset());
  }

  reset() {
    this.lastAction = Date.now();
  }

  initInterval() {
    setInterval(() => {
      this.check();
    }, 1000);
  }

  check() {
    const now = Date.now();

    const timeleft = this.lastAction + 25 * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    if (isTimeout) {
      this._logOutPrompt.next(true);
    }
  }

  logOutSession() {
    this._logOutPrompt.next(false);
    this.msalService.logoutRedirect();

  }
  continueSession() {
    this._logOutPrompt.next(false);
  }
}
